<template>
    <div>
        <div class="pb-2 mb-3" v-if="reviewData">
            <div class="d-flex justify-content-between border-bottom mb-3">
                <h5 class="text-brand">Review</h5>
                <button type="button" @click.prevent="editData" class="btn p-0"><i class="far fa-pen"></i> Edit</button>
            </div>
            <div class="table-responsive">
                <table class="table payment-summery-table" style="font-size: 15px;">
                    <tbody>
                        <tr>
                            <td class="fw-bolder">Please Select Which Statement Best Describes You</td>
                            <td>{{ enrolmentType }}</td>
                        </tr>
                        <tr>
                            <td class="fw-bolder">{{ nameColumn }}</td>
                            <td>{{ reviewData.name }}</td>
                        </tr>
                        <tr>
                            <td class="fw-bolder">{{ maideanName }}</td>
                            <td>{{ reviewData.maiden_name }}</td>
                        </tr>
                        <tr>
                            <td class="fw-bolder">{{ dobColumn }}</td>
                            <td>{{ parseDate(reviewData.date_of_birth) }}</td>
                        </tr>
                        <tr>
                            <td class="fw-bolder">{{ ssnColumn }}</td>
                            <td>{{ reviewData.ssn_4_digit }}</td>
                        </tr>
                        <tr>
                            <td class="fw-bolder">{{ contactColumn }}</td>
                            <td>{{ reviewData.contact_number }}</td>
                        </tr>
                        <tr>
                            <td class="fw-bolder">{{ emailColumn }}</td>
                            <td>{{ reviewData.email }}</td>
                        </tr>
                        <tr>
                            <td class="fw-bolder">Which Document Are You Requesting</td>
                            <td>{{ transcriptType }}</td>
                        </tr>
                        <tr v-if="reviewData.transcript_type == 7">
                            <td class="fw-bolder">Purpose of Enrollment Verification Letter</td>
                            <td>{{ reviewData.document_purpose_parsed }}</td>
                        </tr>
                        <tr v-if="reviewData.student_relation_type">
                            <td class="fw-bolder">Which Best Describe Your Relationship To The Student?</td>
                            <td>{{ yourRelationToStudent }}</td>
                        </tr>
                        <tr v-if="reviewData.program_name">
                            <td class="fw-bolder">Program</td>
                            <td>{{ reviewData.program_name }}</td>
                        </tr>
                        <tr v-if="reviewData.graduation_year">
                            <td class="fw-bolder">Graduation Year</td>
                            <td>{{ reviewData.graduation_year }}</td>
                        </tr>
                        <tr>
                            <td class="fw-bolder">How Would You Like To Receive Your Document(s)?</td>
                            <td>{{ transcriptReceiveType }}</td>
                        </tr>
                        <tr v-if="reviewData.fax_number">
                            <td class="fw-bolder">Please Provide Your Fax Number</td>
                            <td>{{ reviewData.fax_number }}</td>
                        </tr>
                        <tr v-if="isThirdPartyEnrolment && reviewData.request_document_verification == 2">
                            <td class="fw-bolder">Full Mailing Address</td>
                            <td>{{ reviewData.shipping_address_1 }}</td>
                        </tr>
                        <tr v-if="reviewData.name_of_school_or_institute">
                            <td class="fw-bolder">Institute Name</td>
                            <td>{{ reviewData.name_of_school_or_institute }}</td>
                        </tr>
                        <tr v-if="reviewData.attention">
                            <td class="fw-bolder">Attention</td>
                            <td>{{ reviewData.attention }}</td>
                        </tr>
                        <tr v-if="reviewData.institute_email">
                            <td class="fw-bolder">Institute Email</td>
                            <td>{{ reviewData.institute_email }}</td>
                        </tr>
                        <template v-if="[2, 4, '2', '4'].includes(reviewData.transcript_receieve_type)">
                            <tr>
                                <td class="fw-bolder">Street</td>
                                <td>{{ reviewData.shipping_address_1 }}</td>
                            </tr>
                            <tr>
                                <td class="fw-bolder">Apt/Ste #</td>
                                <td>{{ reviewData.shipping_address_2 }}</td>
                            </tr>
                            <tr>
                                <td class="fw-bolder">City</td>
                                <td>{{ reviewData.shipping_city }}</td>
                            </tr>
                            <tr>
                                <td class="fw-bolder">State</td>
                                <td>{{ reviewData.shipping_state }}</td>
                            </tr>
                            <tr>
                                <td class="fw-bolder">Zip code</td>
                                <td>{{ reviewData.shipping_postcode }}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="generic-error"></div>
        <input type="hidden" name="g-recaptcha-response" id="recaptcha">

        <div class="d-flex justify-content-between">
            <div class="form-check">
                <input class="form-check-input" v-model="all_data_correct" type="checkbox" name="is_correct_all_data" required value="" id="all_data_correct">
                <label class="form-check-label" style="cursor: pointer;" for="all_data_correct">
                    All data is correct
                </label>
            </div>

            <button type="button" @click.prevent="onSubmit" :disabled="buttonLoader" class="btn btn-action" style="min-width: 125px;">
                <span v-if="buttonLoader" class="spinner-border spinner-border-sm align-middle" role="status" aria-hidden="true"/>
                <span v-else>Submit Data</span>
            </button>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: 'StepThree',
    mixins: [nccregistrarMixin],
    data() {
        return {
            all_data_correct: false,
            buttonLoader: false,
            reviewData: ''
        }
    },
    created() {
        this.reviewData = JSON.parse(sessionStorage.getItem('stepOneData'));
        setTimeout(() => {
            grecaptcha.execute(this.recaptchaSitekey, {action: 'contact'}).then(function (token) {
                if (token) {
                    document.getElementById('recaptcha').value = token;
                }
            });
        }, 500);
    },
    computed: {
        enrolmentType() {
            let value = '';
            let types = JSON.parse(this.enrollmentTypes);
            for (let key in types) {
                if (key == this.reviewData.enrollment_type) {
                    value = types[key];
                    break;
                }
            }
            return value;
        },
        transcriptType() {
            let val = '';

            if (this.isThirdPartyEnrolment) {
                val = this.reviewData.transcript_type == 1 ? 'Official Transcript' : 'Unofficial Transcript';
            } else {
                let types = JSON.parse(this.transcriptTypesV2);
                for (let key in types) {
                    if (key == this.reviewData.transcript_type) {
                        val = types[key];
                        break;
                    }
                }
            }

            return val;
        },
        transcriptReceiveType() {
            let val = '';

            if (this.isThirdPartyEnrolment) {
                val = this.reviewData.request_document_verification == 1 ? 'Fax' : 'Mail'
            } else {
                let types = JSON.parse(this.transcriptReceiveTypesV2);
                for (let key in types) {
                    if (key == this.reviewData.transcript_receieve_type) {
                        val = types[key];
                        break;
                    }
                }
            }

            return val;
        },
        yourRelationToStudent() {
            let val = '';
            let types = JSON.parse(this.relationToStudent);
            for (let key in types) {
                if (key == this.reviewData.student_relation_type) {
                    val = types[key];
                    break;
                }
            }
            return val;
        },
        isThirdPartyEnrolment() {
            return this.reviewData.enrollment_type == 4;
        },
        nameColumn() {
            return this.isThirdPartyEnrolment ? 'Student\'s Name' : 'Name';
        },
        contactColumn() {
            return this.isThirdPartyEnrolment ? 'Requestor\'s Contact Number' : 'Contact Number';
        },
        maideanName() {
            return this.isThirdPartyEnrolment ? 'Requester\'s Name' : 'Maiden Name (If Applicable)';
        },
        dobColumn() {
            return this.isThirdPartyEnrolment ? 'Student\'s Date of Birth' : 'Date of Birth';
        },
        ssnColumn() {
            return this.isThirdPartyEnrolment ? 'Student\'s Last 4 Digits Of SSN' : 'Last 4 Digits Of SSN';
        },
        emailColumn() {
            return this.isThirdPartyEnrolment ? 'Requestor\'s Email' : 'Email';
        }
    },
    methods: {
        editData() {
            this.$parent.backStepOne();
        },
        onSubmit() {
            if (!this.all_data_correct) {
                document.querySelector('.generic-error').innerHTML = ' * All data is correct is required';
                return;
            } else {
                document.querySelector('.generic-error').innerHTML = '';
            }

            this.buttonLoader = true;

            axios.post(this.baseUrl + '/registrar-submit-final', {id: this.reviewData.id, is_correct: this.all_data_correct})
                .then(response => {
                    this.buttonLoader = false;
                    if (response.data.success) {
                        this.$parent.activeStep = 0;
                        sessionStorage.removeItem('stepOneData');
                        this.$router.push("/success");
                    } else {
                        document.querySelector('.generic-error').innerHTML = response.data.message;
                    }
                })
                .catch(error => {
                    this.buttonLoader = false;
                    console.log(error);
                });
        },
        parseDate(date, format = 'YYYY-MM-DD') {
            return moment(date).format(format);
        }
    }
}
</script>

<style scoped>
.payment-summery-table thead,
.payment-summery-table tbody {
    border-color: unset;
    border-style: unset;
}

.payment-summery-table tr {
    background-color: #f9fafa;
    border: 1px solid #d3d3d3;
}

.payment-summery-table th {
    color: #59169b;
    font-size: 1rem;
    font-weight: 500;
    padding: 20px;
    border-bottom-width: 0;
}

.payment-summery-table td {
    padding: 20px;
    color: #4D4D4D;
}
</style>
